__turbopack_context__.v({
  "blocksBackgroundColor": "Microsite-module-scss-module__7YdpKq__blocksBackgroundColor",
  "blocksFontColor": "Microsite-module-scss-module__7YdpKq__blocksFontColor",
  "closeButtonContainer": "Microsite-module-scss-module__7YdpKq__closeButtonContainer",
  "closeButtonContainerIsOpen": "Microsite-module-scss-module__7YdpKq__closeButtonContainerIsOpen",
  "container": "Microsite-module-scss-module__7YdpKq__container",
  "link": "Microsite-module-scss-module__7YdpKq__link",
  "linkDragging": "Microsite-module-scss-module__7YdpKq__linkDragging",
  "linkIsCurrentPage": "Microsite-module-scss-module__7YdpKq__linkIsCurrentPage",
  "linkReordering": "Microsite-module-scss-module__7YdpKq__linkReordering",
  "linksContainer": "Microsite-module-scss-module__7YdpKq__linksContainer",
  "reorderButtonEnabled": "Microsite-module-scss-module__7YdpKq__reorderButtonEnabled",
  "secondaryNavBackgroundColor": "Microsite-module-scss-module__7YdpKq__secondaryNavBackgroundColor",
  "themeBackgroundColor": "Microsite-module-scss-module__7YdpKq__themeBackgroundColor",
  "themeFontColor": "Microsite-module-scss-module__7YdpKq__themeFontColor",
  "themeFontFamily": "Microsite-module-scss-module__7YdpKq__themeFontFamily",
  "toggle": "Microsite-module-scss-module__7YdpKq__toggle",
  "tooltip": "Microsite-module-scss-module__7YdpKq__tooltip",
});
